export default __webpack_public_path__ + "images/H4.fd24c06.png";